import { Injectable } from '@angular/core';

import { LocalStorageUtil } from '@shared/utils/local-storage/local-storage.util';

const HIDDEN_COMMENT_STORAGE_KEY = 'dood_hidden_comment';
const TTL_MS = 6 * 60 * 60 * 1000; // 6 hours

interface StoredHiddenComment {
  value: string;
  storedAt: number;
}

@Injectable({
  providedIn: 'root',
})
export class HiddenCommentStorageService {
  captureFromQueryParams(params: URLSearchParams): void {
    const value = params.get('appendHiddenComment');
    if (!value) {
      return;
    }

    const stored: StoredHiddenComment = { value, storedAt: Date.now() };
    LocalStorageUtil.set(HIDDEN_COMMENT_STORAGE_KEY, stored);
  }

  getHiddenComment(): string | null {
    const raw = LocalStorageUtil.get(HIDDEN_COMMENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    let parsed: StoredHiddenComment;
    try {
      parsed = JSON.parse(raw) as StoredHiddenComment;
    } catch {
      LocalStorageUtil.remove(HIDDEN_COMMENT_STORAGE_KEY);
      return null;
    }

    if (typeof parsed.storedAt !== 'number' || Date.now() - parsed.storedAt > TTL_MS) {
      LocalStorageUtil.remove(HIDDEN_COMMENT_STORAGE_KEY);
      return null;
    }

    return parsed.value || null;
  }
}
